export enum ACTIONS {
  EARTHQUAKE_LOADER_TOGGLE = 'EARTHQUAKE_LOADER_TOGGLE',
  SET_EARTHQUAKE = 'SET_EARTHQUAKE',
  EARTHQUAKES_LIST_LOADER_TOGGLE = 'EARTHQUAKES_LIST_LOADER_TOGGLE',
  SET_EARTHQUAKES_LIST = 'SET_EARTHQUAKES_LIST',
}
